import React from "react";
import { Box, styled, useTheme } from "@mui/material";
import { Logo } from "@rentablo/components";
import { IconBox } from "@components/Accounts/AccountPreviewCard/IconBox";

export const CircleBox = styled(Box)`
  width: 10px;
  min-width: 10px;
  height: 10px;
  border-radius: 50%;
  content: "";
  border: 1px solid ${({ theme }) => theme.palette.common.white};
`;

export const CircleBoxAbsolute = styled(CircleBox)`
  position: absolute;
  bottom: 0;
  right: 0;
`;

export const LogoImg = styled("img")({
  width: "100%",
  height: "100%",
  objectFit: "contain",
  borderRadius: "4px",
});

export const RecommendationLogo = ({
  imageUrl,
  size = 40,
  alt,
  circleColor,
}: {
  imageUrl?: string | null;
  size?: number;
  alt?: string;
  circleColor?: string;
}) => {
  const theme = useTheme();
  // IconBox scales inline svgs, but Logo renders an <img>, so it keeps its
  // theme-declared size unless width/height are passed explicitly. The <img>
  // also sits on the text baseline, so below ~16px the line box's ascent pushes
  // it off centre — display="flex" takes it out of inline flow.
  const iconSize = size * 0.55;

  return (
    <Box position="relative" display="flex">
      <IconBox bgColor={theme.palette.common.white} size={size}>
        {imageUrl ? (
          <LogoImg src={imageUrl} alt={alt} />
        ) : (
          <Logo
            variant="asset"
            display="flex"
            width={iconSize}
            height={iconSize}
            sx={{ cursor: "inherit" }}
          />
        )}
      </IconBox>
      {circleColor && (
        <CircleBoxAbsolute sx={{ backgroundColor: circleColor }} />
      )}
    </Box>
  );
};
